import { render, staticRenderFns } from "./EventReactionsBar.vue?vue&type=template&id=0bb9e98a&scoped=true"
import script from "./EventReactionsBar.vue?vue&type=script&lang=js"
export * from "./EventReactionsBar.vue?vue&type=script&lang=js"
import style0 from "./EventReactionsBar.vue?vue&type=style&index=0&id=0bb9e98a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb9e98a",
  null
  
)

export default component.exports